export default (data) => ({
    open: true,
    init() {
        //
    },
    dismiss() {
        this.$el.classList.add('transform', 'scale-50', 'opacity-0');

        setTimeout(() => {
            this.open = false;
        }, 200);
    },
});